module.exports = __webpack_public_path__ + "static/media/minor-phonics.b45514b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/minor-phonics.png
// module id = 223
// module chunks = 1